import type { FilterOption } from '@/components/partials/jobs/JobsBackOffice/JobsBackOfficeFilters/types';

export const EMPTY_FILTER_KEY = null;

export const modalNames = Object.freeze({
  ACTIONS_ASSIGN: 'jobs-back-office-actions-assign',
  ACTIONS_DEACTIVATE: 'jobs-back-office-actions-deactivate',
  EDIT_FILTERS: 'jobs-back-office-edit-filters',
  REJECT_HIRING: 'jobs-back-office-reject-hiring',
  REJECT_VACANCY: 'jobs-back-office-reject-vacancy',
  REJECT_INQUIRY: 'jobs-back-office-reject-inquiry',
  CANDIDATES_LIST: 'jobs-back-office-candidates-list',
  PREVIEW_CANDIDATE_CARD: 'jobs-back-office-preview-candidate-card',
  MERGE_WITH_LOCAL_JOB: 'jobs-back-office-merge-with-local-job',
  UPDATE_VACANCY: 'jobs-back-office-update-vacancy',
});

export const ANY_FILTER_KEY = 'any';
export const MAX_ITEMS = 3;

export const MINIMUM_REQUIRED_FIELDS_COUNT = 3;
export const BULLET_MAX_LENGTH = 100;

export const ASSIGNEES_FILTER_UNASSIGNED_OPTION: FilterOption = {
  title: 'Unassigned',
  key: EMPTY_FILTER_KEY,
};

export const TIERS_FILTER_OPTIONS: FilterOption[] = [
  {
    title: 'No Tier',
    key: EMPTY_FILTER_KEY,
  },
  {
    title: 'Tier 0',
    key: 0,
  },
  {
    title: 'Tier 1',
    key: 1,
  },
  {
    title: 'Tier 2',
    key: 2,
  },
  {
    title: 'Tier 3',
    key: 3,
  },
  {
    title: 'Tier 4',
    key: 4,
  },
];

export const DEFAULT_FLAG_OPTIONS: FilterOption[] = [
  {
    title: 'Yes',
    key: true,
  },
  {
    title: 'No',
    key: false,
  },
];
